angular.module('ihestiaRestServicesBase')

/**
 * klauzule produktowe
 */
  .service('policyApkSvc', ['IHestiaRestServiceAbstractDef', function(IHestiaRestServiceAbstractDef) {

    /**
     * Główny konstruktor
     */
    var PolicyApkSvc = function() {
      IHestiaRestServiceAbstractDef.apply(this, arguments);
      var self = this;
      this.resource = 'policies';
      this.businessArea = 'insurance';
      this.port = '8201';
      this.path = 'RestApplications';

      /**
       * pobranie klauzul produktowych dla wniosku
       *
       * @param {String} id
       * @param {String} appMode
       * @param {String} offerId
       * @param {Object} data
       * @param {function} callback
       * @returns {*}
       */
      this.getPolicyDetails = function(policyId, policySymbol, renewalUri, callback, errorCallback, httpParams) {
        if(typeof httpParams === 'undefined' || httpParams === null)
        {
          httpParams = {};
        }

        httpParams.allowedStatuses = [403, 404, 409, 500];
        var data = {
          policyNumber: policyId,
          TechnicalPackage: policySymbol,
          renewalUri: renewalUri
        };
        return self.post(null, data, 'apk', callback, errorCallback, httpParams);
      };

    };
    
    return new PolicyApkSvc();
  }]);